import React from 'react'
// libs
import { WrappedFieldArrayProps } from 'redux-form/lib/FieldArray'
// components
import { ReduxInput, ReduxSelect } from 'components/FormElements'
// types
import { SystemProcessConditionAction } from 'types/graphql'
// views
import { AddButton, CloseIcon, FieldsWrapper, RulesWrapper, RuleWrapper } from './views'
// utils
import { required } from 'utils/validators'

enum FilterFieldName {
  DistinguishedNameOU = 'distinguishedNameOU',
  GroupIds = 'groupIds'
}

export const FILTER_FIELD_NAMES = [
  { label: 'Organisation Unit (Folder)', value: FilterFieldName.DistinguishedNameOU },
  { label: 'Group ID', value: FilterFieldName.GroupIds }
]

export const FILTER_ACTIONS = [
  { label: 'Contains', value: SystemProcessConditionAction.Contains },
  {
    label: 'Is',
    value: SystemProcessConditionAction.Is
  },
  { label: 'Is Not', value: SystemProcessConditionAction.IsNot }
]

const DEFAULT_RULE = {
  conditions: [{ fieldName: FILTER_FIELD_NAMES[0] }]
}

interface RuleProps {
  field: string
  removeRule: () => void
}

const Filter: React.FC<RuleProps> = ({ field, removeRule }) => {
  return (
    <RuleWrapper>
      <FieldsWrapper>
        <span>Where</span>
        <ReduxSelect name={`${field}.conditions[0].fieldName`} options={FILTER_FIELD_NAMES} />
        <ReduxSelect name={`${field}.conditions[0].action`} options={FILTER_ACTIONS} />
        <ReduxInput name={`${field}.conditions[0].value.value`} validate={[required]} />
      </FieldsWrapper>
      <CloseIcon onClick={removeRule} />
    </RuleWrapper>
  )
}

const Filters: React.FC<WrappedFieldArrayProps> = ({ fields }) => {
  const addRule = () => fields.push(DEFAULT_RULE)

  const removeRule = (idx: number) => () => fields.remove(idx)

  return (
    <RulesWrapper>
      <span>Filtering</span>
      {fields.map((field, idx) => (
        <Filter key={field} field={field} removeRule={removeRule(idx)} />
      ))}
      <AddButton onClick={addRule}>+ add filter</AddButton>
    </RulesWrapper>
  )
}

export default Filters
